import { addClasses, removeClasses, toggleClass } from './DOMHelpers';
import { IFrameHelper } from './IFrameHelper';
import { isExpandedView } from './settingsHelper';

export const body = document.getElementsByTagName('body')[0];
export const widgetHolder = document.createElement('div');

export const bubbleHolder = document.createElement('div');
export const chatBubble = document.createElement('button');
export const closeBubble = document.createElement('button');
export const notificationBubble = document.createElement('span');

export const setBubbleText = (bubbleType, bubbleText) => {
  if (isExpandedView(bubbleType)) {
    const textNode = document.getElementById('unthread-widget--expanded__text');

    textNode.innerHTML = bubbleText;
  }
};

export const createBubbleIcon = ({ className, target, position, style, assetsBaseUrl }) => {
  let bubbleClassName = `${className} unthread-elements--${position}`;
  const bubbleIcon = document.createElement('img');
  bubbleIcon.src = `${assetsBaseUrl}/icons/unthread-bubble-icon.svg`;
  bubbleIcon.alt = 'bubble-icon';
  target.appendChild(bubbleIcon);

  if (isExpandedView(style)) {
    const textNode = document.createElement('div');
    textNode.id = 'unthread-widget--expanded__text';
    textNode.innerHTML = '';
    target.appendChild(textNode);
    bubbleClassName += ' unthread-widget--expanded';
  }

  target.className = bubbleClassName;
  return target;
};

export const createBubbleHolder = messageBubbleHidden => {
  if (messageBubbleHidden) {
    addClasses(bubbleHolder, 'unthread-hidden');
  }

  addClasses(bubbleHolder, 'unthread--bubble-holder');

  body.appendChild(bubbleHolder);
};

export const createNotificationBubble = () => {
  addClasses(notificationBubble, 'unthread--notification');
  return notificationBubble;
};

export const onBubbleClick = (state, props = {}) => {
  const { toggleValue } = props;
  const { isOpen } = state;

  if (isOpen !== toggleValue) {
    const newIsOpen = toggleValue === undefined ? !isOpen : toggleValue;

    state.isOpen = newIsOpen;

    toggleClass(chatBubble, 'unthread--hide');
    toggleClass(closeBubble, 'unthread--hide');
    toggleClass(widgetHolder, 'unthread--hide');

    IFrameHelper.events.onBubbleToggle(state, newIsOpen);

    if (!newIsOpen) {
      chatBubble.focus();
    }
  }
};

export const onClickChatBubble = (state) => {
  bubbleHolder.addEventListener('click', (...args) => onBubbleClick(state, ...args));
};

export const addUnreadClass = () => {
  const holderEl = document.querySelector('.unthread-widget-holder');
  addClasses(holderEl, 'has-unread-view');
};

export const removeUnreadClass = () => {
  const holderEl = document.querySelector('.unthread-widget-holder');
  removeClasses(holderEl, 'has-unread-view');
};
